import { useEffect, useState, useCallback } from "react";
import { analyticsAction } from "@/utils/analytics";
import { MASTER_CLIENTS_NS } from "@/i18n/ns";

export const useOpenModalAnalytics = () => {
  useEffect(() => {
    analyticsAction({
      category: "client",
      action: "card_open",
    });
  }, []);
};

const tabToAnalyticsActionMap: Record<string, string> = {
  info: "card_info",
  notify: "card_notifications",
  stats: "card_stat",
};
export const useTabState = (defaultTab?: Maybe<string>) => {
  const [tab, setBaseTab] = useState(defaultTab || "info");

  const setTab = useCallback((newTab) => {
    setBaseTab(newTab);
    if (newTab in tabToAnalyticsActionMap) {
      analyticsAction({
        category: "client",
        action: tabToAnalyticsActionMap[newTab],
      });
    }
  }, []);
  return { tab, setTab };
};

const availableTabs = ["stats", "info", "notify"].map((value) => ({
  value,
  i18nKey: `${MASTER_CLIENTS_NS}:profile_tabs.${value}`,
}));
export const useAvailableTabs = () => availableTabs;
